import { Text } from '@kl/components-v6';
import styled from 'styled-components';
import { LocaleWithLink } from 'shared/ui/no-concat-locale';

export const Dot = styled.span`
    display: inline-block;
    width: 4px;
    height: 4px;
    border-radius: 50%;
    background-color: rgba(31, 50, 71, 0.27);
    vertical-align: middle;
    margin: 0 0.4em;
`;

export const StyledFooterWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
`;

export const StyledFirstLineWrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
`;

export const StyledLocaleWithLink = styled(LocaleWithLink)`
    color: red;
`;

export const StyledChangeLanguageContainer = styled.div`
    width: 20%;

    @media (max-width: 768px) {
        width: 30%;
    }
`;

export const StyledFooterFeaturedPagesLinks = styled(Text)`
    display: inline-flex;
    gap: 1em;
    align-items: center;
`;
